module.exports = __webpack_public_path__ + "img/icon.a03215d1.png";